<template>
  <div
    :style="{background:'url('+ PAGE_PATH.BASE_IMG_URL + detail.banner_img+') '}"
    class="CollectionHeader"
  >
    <div class="inner_center">
      <h1 class="headline">{{ detail.title }}</h1>

      <div class="topic-info">
        {{ detail.picture_total || 0 }}张图片
        <!--        <span></span>-->
        <!--
        0-1昨日，1周内（2-7天），1个月内（8-30天），1个月前（>30天）
        -->
        <!--        156张图片 · 35人订阅 · 昨日更-->

        · {{ detail.subscribe || 0 }}人订阅
        · {{ detail.range_update_days | disposeDay }}更新
      </div>

      <div class="btn-group">
        <SubscriptionBtn class="SubscriptionBtn" :topic-item="detail"/>
        <TopicShare :detail="detail"/>
      </div>

      <!--  返回专题列表 -->
      <CollectionBack class="CollectionBack" :pic="detail.banner_img"/>
    </div>
  </div>
</template>

<script>
import SubscriptionBtn from '@/components/topic/subscription-btn';
import TopicShare from '@/components/topic/topic-share'
import CollectionBack from '@/components/collection/collection-back'
import {PAGE_PATH} from '@/constant/PAGE_PATH'

export default {
  name: "CollectionHeader",
  components: {
    SubscriptionBtn,
    TopicShare,
    CollectionBack
  },
  props: {
    detail: {
      type: Object,
      default: () => {
      },
      required: true
    }
  },
  data() {
    return {
      PAGE_PATH
    }
  },
  methods: {
    // 分享到新浪微博
    share_weibo(event) {
      event.preventDefault()
      // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      // count=表示是否显示当前页面被分享数量(1显示)(可选，允许为空)
      // &url=将页面地址转成短域名，并显示在内容文字后面。(可选，允许为空)
      // &appkey=用于发布微博的来源显示，为空则分享的内容来源会显示来自互联网。(可选，允许为空)
      // &title=分享时所示的文字内容，为空则自动抓取分享页面的title值(可选，允许为空)
      // &pic=自定义图片地址，作为微博配图(可选，允许为空)
      // &ralateUid=转发时会@相关的微博账号(可选，允许为空)
      // &language=语言设置(zh_cn|zh_tw)(可选)
      let currentUrl = String(location.href);
      let title = `我在@潮国创意 发现了【${this.detail.title}专题名】这个特色专题，质量不错创意度好，快来围观！链接：`
      var _shareUrl = 'http://service.weibo.com/share/share.php?'
      _shareUrl += 'url=' + encodeURIComponent(currentUrl) //参数url设置分享的内容链接
      _shareUrl += '&title=' + encodeURIComponent(title) //参数title设置分享的标题
      _shareUrl += '&pic=' + PAGE_PATH.BASE_IMG_URL + this.detail.cover_img //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
        'height=800, width=1000',
        'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
      )
    },
  },
  filters: {
    disposeDay(day) {
      if (day > 30) {
        return '一个月前'
      } else if (day > 8) {
        return '1个月内'
      } else if (day > 2) {
        return '1周内'
      } else {
        return '昨天'
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.CollectionHeader {
  height: 220px;
  background: #FFF7E3;
  box-sizing: border-box;

  .inner_center{
    padding-top: 36px;
    position: relative;

    .CollectionBack{
      @include Position(1,2,0,0);
    }
  }

  .headline {
    font-size: 38px;
    font-weight: bold;
    color: #333333;
    line-height: 50px;
    letter-spacing: 3px;
    //margin-bottom: 28px;
  }

  .topic-info {
    font-size: 14px;
    color: #0A2540;
    line-height: 19px;
    margin: 10px 0 28px;

    span {
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #0A2540;
      border-radius: 1px;
      color: rgba(10, 37, 64, 0.8);
      margin: 0 10px;
    }
  }

  .btn-group {
    display: flex;
    align-items: center;

    .SubscriptionBtn {
      margin-right: 20px;

      /deep/ .subscription {
        line-height: 44px !important;
        height: 44px;
      }
    }
  }

}


.back-btn {
  width: 102px;
  height: 44px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(10, 37, 64, 1);
  font-size: 14px;
  color: #0A2540;
  cursor: pointer;
  position: relative;
  margin-left: 20px;

  .icon-back {
    margin-right: 8px;
    font-size: 18px;

    @include BgImage(12px, 12px, 'topic/index/back.svg')
  }

  &:hover {
    background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
    color: #FFFFFF;
  }
}
</style>
